import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const PopUp = ({ classes, className, children }) => {
  return (
    <div className={classes.container}>
      <div className={classNames(classes.popup, className)}>{children}</div>
    </div>
  )
}

PopUp.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({
    container: PropTypes.string,
    popup: PropTypes.string,
    button: PropTypes.string,
  }),
  children: PropTypes.node,
}

export default PopUp
